import React from 'react';
import { Avatar } from '@guuru/react-expert-avatar';

interface PhotoProps {
  expert: {
    photoUrl?: string | null;
    name?: string;
  }
}

const Photo = function ({ expert }: PhotoProps) {
  const { name, photoUrl } = expert;
  return (
    <Avatar
      src={photoUrl}
      text={name}
      shape="square"
      style={{
        objectFit: 'cover',
        aspectRatio: '1 / 1',
        width: '100%',
        height: '100%',
        border: 'inherit',
      }}
    />
  );
};

export default Photo;
